import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`navbar ${isScrolled ? "scrolled" : ""} ${
        isMobileMenuOpen ? "mobile-open" : ""
      } ${isHomePage ? "home-navbar" : ""}`}
    >
      <div className="container nav-container">

        {/* LEFT: Logo */}
        <div className="logo-section">
          <Link to="/" className="logo-link">
            <div className="logo-container">
              <img
                src="/logos.png"
                alt="SeagullPartners Logo"
                className="logo-image"
              />

              {/* Desktop text logo */}
              <div className="text-logo">
                <span className="logo-text-seagull">Seagull</span>
                <span className="logo-text-partners">Partners</span>
              </div>
            </div>
          </Link>
        </div>

        {/* CENTER: Brand text (Mobile / Tablet only) */}
        <span className="mobile-brand-text">
          <span className="logo-text-seagull">Seagull</span>
          <span className="logo-text-partners">Partners</span>
        </span>

        {/* RIGHT: Hamburger */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

        {/* Navigation Links */}
        <div className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
          <div className="nav-left">
            <Link to="/" className="nav-link"><span className="nav-link-text">HOME</span></Link>
            <Link to="/about" className="nav-link"><span className="nav-link-text">ABOUT</span></Link>
            <Link to="/why-seagull" className="nav-link"><span className="nav-link-text">WHY SEAGULL</span></Link>
            <Link to="/solutions" className="nav-link"><span className="nav-link-text">OUR SOLUTION</span></Link>
            <Link to="/products-industries" className="nav-link"><span className="nav-link-text">PRODUCTS & INDUSTRIES</span></Link>
            <Link to="/contact" className="nav-link"><span className="nav-link-text">CONTACT</span></Link>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
